import Text from "@/components/typographie/Text/Text";
import IconRenderer from "@/libs/contentful/helper/IconRenderer";
import clsx from "clsx";
import React, {useState} from "react";
import {useTranslations} from "next-intl";

interface Props {
    label: string
    type: string
    palceholder?: string
    name: string
    value?: string
    isRequired?: boolean
    checked?: boolean
}

export default function Input({label, type, palceholder, name, value, isRequired = false, checked}:Props) {
    const t = useTranslations("Forms")
    let labelClass;
    let textType;
    let textClass;
    let inputClass;
    let pattern;
    let validation = 'peer invalid:focus:border-warning invalid:[&:not(:placeholder-shown):not(:focus)]:border-error valid:[&:not(:placeholder-shown)]:border-success';
    let helperText;
    switch (type) {
        case 'radio':
            labelClass = 'flex flex-start gap-s items-center cursor-pointer'
            textClass = 'order-2'
            inputClass = 'order-1 cursor-pointer appearance-none bg-white w-[24px] h-[24px] border rounded-full grid place-items-center before:w-[12px] before:h-[12px] before:rounded-full before:shadow-radioButton before:brand-transition before:scale-0 checked:before:scale-100'
            validation = ''
            break
        case 'text':
            labelClass = 'relative'
            textType = 'form-label'
            inputClass = 'w-full p-[10px] border border-black/40 rounded-[2px]'
            break
        case 'email':
            labelClass = 'relative'
            textType = 'form-label'
            inputClass = 'w-full p-[10px] border border-black/40 rounded-[2px]'
            pattern = '[^@\\s]+@[^@\\s]+\\.[^@\\s]+'
            helperText = 'Bitte geb eine gültige E-Mail Adresse ein.'
            break
        default:
            return null
    }

    const emptyLabel = (e:any) => {
        e.target.previousSibling.value = ''
    }

    const [clearIcon,setClearIcon] = useState(false)

    return (
        <label className={labelClass}>
            <Text type={textType} className={textClass}>{label}</Text>
            <input type={type} placeholder={palceholder} name={name} value={value} required={isRequired}
                   className={clsx(validation, inputClass)} pattern={pattern} defaultChecked={checked} onChange={(e) =>setClearIcon(!!e.target.value)} />
            {type !== 'radio' &&
                clearIcon ?
                <button type="button" onClick={(e) => { emptyLabel(e); setClearIcon(false)}} className="absolute top-[0] right-[0] h-[46px] w-[45px] flex justify-center items-center" aria-label={t("deleteInput") + ' ' + label}>
                    <IconRenderer icon="icon-close" className="w-[16px] h-[16px] pointer-events-none" /></button>: null
            }
            {helperText && <Text type="tiny"
                className="mt-s ml-[10px] hidden text-error peer-[&:not(:placeholder-shown):not(:focus):invalid]:block">
                {helperText}
            </Text>}
        </label>
    )
}